import {Calendar} from '@fullcalendar/core';
import locale from '@fullcalendar/core/locales/cs';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import momentTimezonePlugin from '@fullcalendar/moment-timezone';
import moment from "moment/moment";

// Calendar
$(document).ready(function () {
	'use strict';

	let $calendarEl = $('#calendar');

	if (
		$calendarEl.length === 0
	) {
		return;
	}

	let calendarStep = parseInt($calendarEl.data('step'), 10);
	let calendarMaxDate = new Date($calendarEl.data('max-date') + ' ' + $calendarEl.data('opening-hours-to') + ':00.0');
	let calendarMaxDateBySlot = calendarMaxDate.getDatetimeBySlot(calendarStep);
	let calendar = new Calendar($calendarEl[0], {
		timeZone:        $calendarEl.data('timezone'),
		plugins:         [interactionPlugin, timeGridPlugin, momentTimezonePlugin],
		locale:          locale,
		allDaySlot:      false,
		firstDay:        1,
		contentHeight:   'auto',
		slotLabelFormat: {
			hour:     'numeric',
			minute:   '2-digit',
			meridiem: false,
			hour12:   false
		},
		headerToolbar:   {
			left:  'prev,next',
			right: 'title',
			// left:   'prev,next today',
			// center: 'title',
			// right:  'timeGridWeek,timeGridDay',
		},
		validRange:      {
			start: $calendarEl.data('min-date'),
			end:   moment(calendarMaxDateBySlot).format('YYYY-MM-DD'),
		},
		slotMinTime:     $calendarEl.data('opening-hours-from') + ':00',
		slotMaxTime:     $calendarEl.data('opening-hours-to') + ':00',
		events:          $calendarEl.data('ajax-action-list'),
		eventDidMount: function (info) {
			let $element = $(info.el);
			$element.attr('title', $element.find('.fc-event-title').text());
		},
		selectable:      false,
		slotDuration:    $calendarEl.data('slot-duration'),
	});

	if ($(window).width() <= 1024) {
		calendar.changeView('timeGridDay');
	}

	calendar.render();
});
